import React from "react";
import styles from "./index.module.scss";
export default function CallingStatusTag({
  callingStatus
}: {
  callingStatus: string | null;
}) {
  return (
    <>
      {callingStatus !== null && (
        <div
          className={`${styles.TAG} ${
            styles[callingStatus?.replaceAll(" ", "").toLowerCase()]
          }`}
        >
          {callingStatus}
        </div>
      )}
    </>
  );
}
